
import Vue from "vue";
import { NewTabletsApiFunc, setAccessToken } from "@/api";
import { Tablet, TabletStatus } from "@/models";

import TheTemplate from "../components/TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";
import moment from "moment";

export type DataType = {
  tablet?: Tablet;
};

function convertTabletStatus(rawTabletStatus?: TabletStatus): string {
  switch (rawTabletStatus) {
    case TabletStatus.UNINITIALIZED:
      return "未初期化";
    case TabletStatus.RUNNING:
      return "稼動";
    case TabletStatus.SUSPENDED:
      return "停止";
    default:
      return "不明";
  }
}

export default Vue.extend({
  name: "TabletDeleteScreen",

  components: {
    TheTemplate,
    BaseCloseButton,
    BaseSubmitButton,
    BaseCancelButton,
  },

  data(): DataType {
    return {
      tablet: new Tablet(),
    };
  },

  computed: {
    companyNameText(): string {
      return this.$globalData.companyName || "";
    },

    tabletMacAddressText(): string {
      return this.tablet?.mac || "";
    },

    statusText(): string {
      if (!this.tablet?.details) {
        return "";
      } else {
        return convertTabletStatus(this.tablet?.details?.status);
      }
    },

    statusClassText(): string {
      switch (this.tablet?.details?.status) {
        case TabletStatus.UNINITIALIZED:
          return "red";
        case TabletStatus.RUNNING:
          return "";
        case TabletStatus.SUSPENDED:
          return "red";
        default:
          return "red";
      }
    },

    checkedTimingText(): string {
      if (!this.tablet?.details?.latestDateTime) return "なし";
      return moment(this.tablet?.details?.latestDateTime).format(
        "YYYY-MM-DD(HH:mm:ss)"
      );
    },
  },

  mounted() {
    this.getTablet();
  },

  methods: {
    async getTablet(): Promise<void> {
      const companyId = this.$router.currentRoute.params.companyId;
      const tabletId = this.$router.currentRoute.params.tabletId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewTabletsApiFunc().adminGetTablet(
        companyId,
        tabletId
      );

      if (err != null) {
        this.$handleApiError(err, this.getTablet);
        return;
      }

      this.tablet = data;
    },

    async unassignTablet(): Promise<void> {
      this.$setLoading(true);

      const companyId = this.$router.currentRoute.params.companyId;
      const tabletId = this.$router.currentRoute.params.tabletId;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewTabletsApiFunc().adminUnassignTablet(
        companyId,
        tabletId
      );

      if (err != null) {
        this.$handleApiError(err, this.unassignTablet);
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-tablets",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
